import gql from 'graphql-tag';

export const getServiceRequestAuditLogsQuery = gql`
  query ServiceRequestAuditLogs($serviceRequestId: String!) {
    serviceRequestAuditLogs(serviceRequestId: $serviceRequestId) {
      userName
      userImageUrl
      actions {
        field
        title
        previousState
        currentState
      }
      date
    }
  }
`;
